import {ThemeProvider} from "../ThemeProvider";
import {CongratsUpper, CongratsLower, BackgroundImage} from "./congrats/Components.js"
import Footer  from "./Footer/Footer.js"

export class PlusThemeProvider implements ThemeProvider {
    CMSPrefix: 'string';
    header = {
        Logo: {
            uri: process.env.REACT_APP_LOGO_URI,
            img: <img src="images/ant1Logo.png"
                      alt="ant1 logo"
                      className="ant1-logo"/>
        }
    }
    Footer = Footer;
    uris = {
        other: {
            termsAndConditions: process.env.REACT_APP_THEME_PLUS_TERMS_URI
        }
    }
    congrats = {
        ContentContainerUpper: CongratsUpper,
        ContentContainerLower: CongratsLower,
        BackgroundImage: BackgroundImage,
        primaryCTA: true
    };
}